var _ellipse, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeedbackLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.9995,
    cy: 20,
    rx: 19.9995,
    ry: 20,
    fill: "url(#paint0_linear_23645_130551)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5127 4.33788C30.5658 4.2926 30.6015 4.22962 30.6135 4.16007C30.6255 4.09052 30.6131 4.01888 30.5784 3.95779C30.5437 3.89671 30.4889 3.85011 30.4239 3.82623C30.3588 3.80235 30.2875 3.80273 30.2227 3.8273L14.2221 10.1065C12.8238 10.661 11.697 11.7579 11.0876 13.1578C10.4782 14.5577 10.4357 16.1469 10.9694 17.5787L11.0191 17.7096C11.2066 18.1613 12.0189 19.6554 14.6099 19.8682L25.1642 20.7355C25.3162 20.7481 25.461 20.8068 25.58 20.9041C25.6991 21.0014 25.7869 21.1329 25.8322 21.2816C25.8775 21.4302 25.8782 21.5894 25.8343 21.7385C25.7904 21.8876 25.7038 22.0199 25.5857 22.1183L9.3463 35.6603C9.29323 35.7055 9.25755 35.7685 9.24555 35.8381C9.23354 35.9076 9.24598 35.9793 9.28067 36.0403C9.31537 36.1014 9.37008 36.148 9.43515 36.1719C9.50023 36.1958 9.57147 36.1954 9.6363 36.1708L25.6353 29.8916C27.034 29.3375 28.1611 28.2407 28.7708 26.8408C29.3805 25.4408 29.4232 23.8514 28.8896 22.4194L28.8223 22.2427C28.6044 21.7517 27.7744 20.364 25.3229 20.1349L14.6948 19.2627C14.5428 19.2501 14.398 19.1913 14.279 19.094C14.16 18.9967 14.0721 18.8653 14.0268 18.7166C13.9815 18.5679 13.9808 18.4088 14.0247 18.2597C14.0687 18.1106 14.1553 17.9783 14.2734 17.8798L30.5127 4.33788Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23645_130551",
    x1: -2.23512e-7,
    y1: 20,
    x2: 39.9991,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A16AF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336458,
    stopColor: "#479AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633333,
    stopColor: "#479AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FC9B8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackLogo);
export default __webpack_public_path__ + "static/media/feedback_logo.932d69af9726981537f51ce7861196f5.svg";
export { ForwardRef as ReactComponent };